import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ALERTS_PAUSED_DATE, DATE_FORMAT } from "../config/constants";
import { getFromLocal, saveToLocal } from "../helpers/handleLocalStorage";
import { isLayoutTall } from "../lib/redux/slices/layoutSlice";

/**
 * @since March 2024
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 */

export const useHandleDismissAlert = () => {
  const [isDismissModalVisible, setIsDismissModalVisible] = useState(false);
  const [areAlertsPaused, setAreAlertsPaused] = useState(false);
  const dispatch = useDispatch();

  const today = dayjs().format(DATE_FORMAT.yearDateFormat);

  const handleShowDismissModal = () => {
    setIsDismissModalVisible(true);
  };

  const handleDismissAlerts = () => {
    setAreAlertsPaused(true);
    dispatch(isLayoutTall(true));
    saveToLocal({ name: ALERTS_PAUSED_DATE, value: today });
  };

  // check if alerts are still paused
  useEffect(() => {
    const pausedDate = getFromLocal(ALERTS_PAUSED_DATE);
    try {
      const daysSincePaused = dayjs(today).diff(pausedDate, "date");
      const arePaused = daysSincePaused >= 0 && daysSincePaused <= 7;
      setAreAlertsPaused(arePaused);
      dispatch(isLayoutTall(arePaused));
    } catch (err) {
      dispatch(isLayoutTall(false));
      setAreAlertsPaused(false);
    }
  }, [dispatch, today]);

  return {
    isDismissModalVisible,
    setIsDismissModalVisible,
    handleShowDismissModal,
    handleDismissAlerts,
    areAlertsPaused
  };
};
